import React from 'react';
import { FileIconBase } from './_base';
const ArchiveFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#8E8E93", label: "ZIP" })));
export default ArchiveFileIcon;
